export const contactMethod = [
  { value: "LINE" },
  { value: "WECHAT" },
  { value: "QQ" },
  { value: "WHATSAPP" },
  { value: "TELEGRAM" },
];
